import CategoryInput from './category-input';

export default CategoryInput;
